(() => {
 if (window.siennaProtectionLoaded) return;
 window.siennaProtectionLoaded = true;
 let busy = false, scheduled;
 const root = () => document.querySelector('[data-sienna-protection]');
 const lines = el => JSON.parse(el.querySelector('[data-protection-lines]').textContent);
 async function update(enabled, automatic = false) {
  const el = root();
  if (!el || busy) return;
  const current = lines(el), target = Number(el.dataset.target);
  if (automatic && (!current.length || (Number(el.dataset.count) > 0 && current.length === 1 && current[0].id === target && current[0].quantity === 1))) return;
  enabled = enabled && Number(el.dataset.count) > 0;
  const updates = Object.fromEntries(current.map(item => [item.key, 0]));
  if (enabled) {
   const existing = current.find(item => item.id === target);
   updates[existing ? existing.key : target] = 1;
  }
  if (!Object.keys(updates).length) return;
  busy = true;
  const toggle = el.querySelector('[data-protection-toggle]');
  if (toggle) toggle.disabled = true;
  const checkout = document.getElementById('CartDrawer-Checkout');
  if (checkout) checkout.disabled = true;
  try {
   const response = await fetch((window.Shopify.routes.root || '/') + 'cart/update.js', {
    method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
    body: JSON.stringify({updates, sections: ['cart-drawer','cart-icon-bubble'], sections_url: location.pathname})
   });
   const cart = await response.json();
   if (!response.ok || cart.errors || !cart.sections?.['cart-drawer']) throw new Error();
   const drawer = document.querySelector('cart-drawer');
   drawer.classList.toggle('is-empty', cart.item_count === 0);
   drawer.renderContents(cart);
   if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source:'sienna-protection',cartData:cart});
  } catch {
   const currentRoot = root(), error = currentRoot?.querySelector('[data-protection-error]');
   if (error) { error.textContent = currentRoot.dataset.error; error.hidden = false; }
   if (toggle) toggle.checked = current.length > 0;
  } finally {
   busy = false;
   const currentToggle = root()?.querySelector('[data-protection-toggle]');
   if (currentToggle) currentToggle.disabled = false;
   const currentCheckout = document.getElementById('CartDrawer-Checkout');
   if (currentCheckout) currentCheckout.disabled = !Number(root()?.dataset.count || 0);
   schedule();
  }
 }
 function schedule() {
  clearTimeout(scheduled);
  scheduled = setTimeout(() => {
   const el = root();
   if (el && !busy && lines(el).length) update(true,true);
  }, 350);
 }
 document.addEventListener('change', event => {
  if (event.target.matches('[data-protection-toggle]')) update(event.target.checked);
 });
 const init = () => {
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(schedule).observe(drawer,{childList:true,subtree:true});
  schedule();
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();